<div class="bmc-connect-event">
  <div class="bmc-event">
    <div class="bmc-event__list">
      <h4 class="bmc-event__list__title">{{'EVENT_STREAMING.CONNECTOR_LIST' | translate}}</h4>
      <ul class="bmc-event-list">
        <li *ngFor="let eventModel of eventStreamType">
          <div class="bmc-event-list__item" (click)="eventModel.isExpanded = !eventModel.isExpanded">
            <bzg-icon [nameIcon]="!eventModel.isExpanded ? 'arrow-up' : 'arrow-down'" [size]="14" *ngIf="eventModel.events && eventModel.events.length"></bzg-icon>
            <div class="bmc-event-list__item__text bz-flex">
              <span class="bmc-event-name">{{eventModel.name}}</span>
            </div>
          </div>
          <ul *ngIf="eventModel.isExpanded && eventModel.events.length" [@bzgSlideDown]>
            <li class="bmc-event-sublist" *ngFor="let eventConn of eventModel.events"
              (click)="selectKafkaConnection(eventConn)"
              [ngClass]="{'bz-color-bg--theme-100': selectedEvent && (selectedEvent.id === eventConn.id )}">
              <span class="">{{eventConn.displayName}}</span>
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <div class="bmc-event-config">
      <!-- Loading overlay - positioned on top of everything -->
      <div class="bmc-event-config__loading" *ngIf="isBusy">
        <bz-loading size="xl"></bz-loading>
      </div>

      <!-- Content wrapper with disabled state when loading -->
      <div class="bmc-event-config__content" [class.content-loading]="isBusy">
        <!-- Message displayed when no events are available -->
        <div class="bmc-event-config__no-config"
          *ngIf="eventStreamType && eventStreamType[0] && eventStreamType[0].events.length === 0">
          <p>{{ 'EVENT_STREAMING.NO_CONNECTIONS' | translate }}</p>
        </div>

        <!-- Message displayed when no connection is selected -->
        <div class="bmc-event-config__no-config" *ngIf="!selectedEvent && eventStreamType[0] && eventStreamType[0].events.length > 0">
          <p>{{ 'EVENT_STREAMING.SELECT_CONNECTION' | translate }}</p>
        </div>

        <!-- Message displayed when connection is selected but has no environment configuration -->
        <div class="bmc-event-config__no-config" *ngIf="selectedEvent && !selectedEvent.environment">
          <p>{{ 'EVENT_STREAMING.NO_CONFIGURATION_AVAILABLE' | translate }}: <b>{{ selectedEvent.displayName }}</b></p>
        </div>

        <!-- Main configuration container displayed when connection has valid environment -->
        <div class="bmc-event-config__container" *ngIf="selectedEvent && selectedEvent.environment">
          <div class="bmc-event-detail">
            <biz-connect-event-streaming-detail 
              #eventStreamingDetail 
              *ngIf="selectedEvent"
              [kafkaConfiguration]="selectedEvent" 
              (onSave)="saveKafkaConfiguration()" 
              (onCancel)="cancelChanges()"
              (onLoadingChange)="handleLoadingChange($event)">
            </biz-connect-event-streaming-detail>
          </div>

          <!-- Action buttons for Save and Cancel -->
          <div class="bmc-event-config__buttons" *ngIf="selectedEvent">
            <bzg-button-secondary class="bz-space--inline-m" (click)="cancelChanges()">
              {{ 'GLOBAL.CANCEL' | translate }}
            </bzg-button-secondary>
            <bzg-button-primary (click)="saveKafkaConfiguration()">
              {{ 'GLOBAL.APPLY' | translate }}
            </bzg-button-primary>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>